import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';

/**
 * Full-screen terminal state shown when `BrandService` could not resolve a brand
 * for the current host — an unmapped/deactivated custom domain, or a failed
 * `resolveBrand` call. `AppComponent` renders this INSTEAD of the router outlet,
 * so nothing (including the login flow) is reachable in that state.
 *
 * Branding is deliberately neutral: the host belongs to a customer whose brand we
 * failed to resolve, so the Tefter wordmark must not be asserted on it.
 */
@Component({
  selector: 'app-service-unavailable',
  standalone: true,
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon, TranslocoDirective, LanguageSwitcherComponent],
})
export class ServiceUnavailableComponent {
  private doc = inject<Document>(DOCUMENT);

  /** Full reload — brand resolution only runs in APP_INITIALIZER, so re-running it means re-bootstrapping. */
  reload(): void {
    this.doc.defaultView?.location.reload();
  }
}
